import { Outlet, ScrollRestoration } from "react-router";
// import { Icon } from "@iconify-icon/react";
import FileInfo from "@/components/Icons/FileInfo";
import { ToastContainer, Slide } from "react-toastify";

// -----------------------------------------------------------------------------

export default function App() {
	return (
		<>
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
				transition={Slide}
				icon={<FileInfo />}
			/>

			{/* Child routes will render here */}
			<Outlet />

			{/* Handles scroll restoration */}
			<ScrollRestoration />
		</>
	);
}
